import React from "react";
import { CircularProgress } from "@mui/material";
import { colorTokens, getSpacing, getTypography } from "../../../designTokens";

export interface CenteredPageLoaderProps {
  message: string;
  id?: string;
  spinnerSize?: number;
}

export const CenteredPageLoader: React.FC<CenteredPageLoaderProps> = ({
  message,
  id,
  spinnerSize = 32,
}) => (
  <div
    id={id}
    role="status"
    aria-live="polite"
    aria-busy="true"
    style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: getSpacing("12px"),
    }}
  >
    <CircularProgress
      size={spinnerSize}
      aria-hidden="true"
      sx={{ color: colorTokens["Primary/Default"] }}
    />
    <p
      style={{
        ...getTypography("Body/Medium"),
        color: colorTokens["Text/Light Grey"],
        margin: 0,
        textAlign: "center",
      }}
    >
      {message}
    </p>
  </div>
);

